import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

export interface Config {
  gatewayUrl: string;
  debug: boolean;
  debugUsername: string;
  debugPin: string;
  debugScope: string;
  debugSede: string;
  usernameLabel: string;
  pinLabel: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  configUrl = 'assets/config.json';

  private config: Config;

  constructor(private http: HttpClient) { }

  getConfig() {
    return this.http.get<Config>(this.configUrl)
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError) // then handle the error
      );
  }

  ensureConfig(): Observable<any> {
    return new Observable(observer => {
      this.getConfig().subscribe(config => {
        this.setConfig(config);
//      console.log(`config = ${JSON.stringify(this.config)}`);
        observer.next();
      })
    });
  }

  getBackendUrl(path: string): string {
    const url = this.config.gatewayUrl + path;
    console.log(`getting gateway url ${url}`);
    return url;
  }

  isDebug(): boolean {
    return this.config.debug;
  }

  getDebugUsername(): string {
    return this.config.debugUsername;
  }

  getDebugPin(): string {
    return this.config.debugPin;
  }

  getDebugScope(): string {
    return this.config.debugScope;
  }

  getDebugSede(): string {
    return this.config.debugSede;
  }

  getUsernameLabel(): string {
    return this.config.usernameLabel || "USERNAME";
  }

  getPinLabel(): string {
    return this.config.pinLabel || "PIN";
  }

  private setConfig(config: Config) {
    this.config = config;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

}
